module.exports = __webpack_public_path__ + "static/media/leading-wellbeing-large@2x.dab24079.png";